/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getNextNavigableItem(items) {
  var startFrom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var nextNavigableItem = null;
  if (!items || items && !items.length) {
    return null;
  }
  if (startFrom === null) {
    return null;
  }
  if (direction === 1) {
    for (var i = startFrom + 1, len = items.length; i < len; i++) {
      var item = items[i];
      var isDisabled = item && item.disabled;
      var isSeparator = item === '-';
      var isTitle = item.isTitle;
      if (!isSeparator && !isDisabled && !isTitle) {
        nextNavigableItem = i;
        break;
      }
    }
  } else {
    for (var _i = startFrom - 1; _i >= 0; _i--) {
      var _item = items[_i];
      var _isDisabled = _item && _item.disabled;
      var _isSeparator = _item === '-';
      var _isTitle = _item.isTitle;
      if (!_isSeparator && !_isDisabled && !_isTitle) {
        nextNavigableItem = _i;
        break;
      }
    }
  }
  return nextNavigableItem;
}
var _default = getNextNavigableItem;
exports.default = _default;